import React from 'react'

export const Card = ({ icon, count, name, color }) => {
  return (
    <div className='card-container bg-white d-flex align-items-center'>
        <div className='card-icon p-2'>
        <div className="card-icon-border" style={{ backgroundColor: color }}></div>
           <img src={icon} />
        </div>
        <div className='card-info'>
          <div className="card-count">{count}</div>
          <div className="card-name ">{name}</div>
        </div>
    </div>
  )
}
